import { useEffect } from 'react';
import { Lock } from 'lucide-react';

export default function SessionExpiredModal({ visible }) {
    useEffect(() => {
        if (visible) document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = 'unset'; };
    }, [visible]);

    if (!visible) return null;

    const handleLogin = () => {
        window.location.href = '/login';
    };

    return (
        <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center">
            <div className="bg-white rounded-xl p-6 sm:p-8 w-full max-w-[340px] mx-4 text-center shadow-lg">

                <div className="flex items-center justify-center w-14 h-14 rounded-full bg-red-100 mx-auto mb-4">
                    <Lock className="text-red-500" size={24} />
                </div>

                <h2 className="text-lg font-medium text-gray-900 mb-2">
                    Session expired
                </h2>

                <p className="text-sm text-gray-500 leading-relaxed mb-6">
                    Your session has expired. Please log in again to continue.
                </p>

                <button
                    onClick={handleLogin}
                    className="w-full py-2.5 rounded-lg bg-gradient-to-r from-[#161612] to-[#38433a] text-white text-sm font-medium cursor-pointer hover:opacity-90 transition-opacity"
                >
                    Go to login
                </button>

            </div>
        </div>
    );
}